import React, { FC } from 'react';
import { MessageCard } from '../../components';
import { useTranslation } from '../../translations';

export const RegistrationClosed: FC = () => {
  const { ts } = useTranslation();
  return (
    <MessageCard icon="remove_circle" id="registrationClosed" level="danger">
      {ts('registration_for_the_convention_is')}
    </MessageCard>
  );
};
